import React, { useState, useMemo } from 'react';
import {
  IoSearchOutline,
  IoStorefrontOutline,
  IoCloseOutline,
  IoLocationOutline,
} from 'react-icons/io5';
import styles from './SalesPointList.module.css';

export default function SalesPointList({
  salesPoints = [],
  selectedId = null,
  onSelect,
  entityName = '',
}) {
  const [searchQuery, setSearchQuery] = useState('');

  const filtered = useMemo(() => {
    if (!searchQuery.trim()) return salesPoints;
    const q = searchQuery.toLowerCase();
    return salesPoints.filter(sp =>
      (sp.name || '').toLowerCase().includes(q) ||
      (sp.phone_num || '').toLowerCase().includes(q) ||
      (sp.status || '').toLowerCase().includes(q)
    );
  }, [salesPoints, searchQuery]);

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <div className={styles.headerTitle}>
          <IoStorefrontOutline size={16} />
          <h3>Sales Points</h3>
        </div>
        <span className={styles.count}>{filtered.length}</span>
      </div>

      {entityName && (
        <div className={styles.entityBadge}>{entityName}</div>
      )}

      <div className={styles.searchBar}>
        <IoSearchOutline className={styles.searchIcon} size={16} />
        <input
          type="text"
          placeholder="Search sales points..."
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
        />
        {searchQuery && (
          <button className={styles.clearBtn} onClick={() => setSearchQuery('')}>
            <IoCloseOutline size={16} />
          </button>
        )}
      </div>

      <div className={styles.list}>
        {salesPoints.length === 0 ? (
          <div className={styles.empty}>
            {entityName ? 'No sales points for this entity' : 'Select an entity to view sales points'}
          </div>
        ) : filtered.length === 0 ? (
          <div className={styles.empty}>No results for "{searchQuery}"</div>
        ) : (
          filtered.map(sp => {
            const isSelected = selectedId === sp.id;
            const statusColor = sp.status === 'Confirmed' ? '#1F8B50' : '#D16A2D';

            return (
              <div
                key={sp.id}
                className={`${styles.card} ${isSelected ? styles.selected : ''}`}
                onClick={() => onSelect?.(sp)}
              >
                <div className={styles.cardIcon}>
                  <IoLocationOutline size={18} />
                </div>
                <div className={styles.cardInfo}>
                  <div className={styles.cardName}>{sp.name || 'Unnamed'}</div>
                  <div className={styles.cardMeta}>
                    {sp.phone_num && <span>{sp.phone_num}</span>}
                    {sp.status && (
                      <span className={styles.statusBadge} style={{ color: statusColor, borderColor: statusColor }}>
                        {sp.status}
                      </span>
                    )}
                  </div>
                </div>
                {isSelected && <div className={styles.focusIndicator} />}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
